
import React, { useState } from 'react';
import { routePaths } from '@/config';
import { TextField, Button } from '@mui/material';
import { Link, useNavigate } from "react-router-dom";
import './ForgottenPasswordForm.styles.scss';
import { ToastError, ToastGeneric } from '@/utils/toast';
import * as Yup from "yup";
import { useFormik } from "formik";
import { apiResetPasswordSendMail } from '../../api/auth.api';
import { InlineIcon } from '@iconify/react';
import { Loader } from '@/components/Loader/Loader';
import ResetPasswordForm from '../ResetPasswordForm/ResetPasswordForm';

const ForgottenPasswordForm:React.FC = () =>  {

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [currentIdUser, setCurrentIdUser] = useState(0)
  const [isResetPassword, setIsResetPassword] = useState(true);
  const goTo = (route:string) => {
      navigate(route,{replace:true});
      ToastGeneric(`Code OTP envoyé. Consulter votre boite email`, 'success', 3000).fire();
  }

  const validationSchema: any = Yup.object({
    email: Yup.string()
      .email("L'email n'est pas valide !")
      .required("veuillez renseigner un email valide !"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (value) => {
      console.log(value);
      setIsLoading(true);
      sendMailForResetPassword()
    },
  });

  const sendMailForResetPassword = () => {
    apiResetPasswordSendMail({
      email: formik.values.email,
    }).then((response) => {
      console.log(" res^ponse ",response);
      setIsLoading(false);
      if (!response.error) {
        if(response.data && response.data.user_id) {
          setCurrentIdUser(response.data.user_id);
          setIsResetPassword(false);
        }
       
        ToastGeneric(
          "Veuillez recupérer le code que nous avons envoyé à l'adresse " +
            formik.values.email,
          "success",
          3000
        ).fire();
      }else {
        ToastError.fire({ text: response.message, timer: 9000 });
      }
    }).catch( (error) => {
      setIsLoading(false);
      ToastError.fire({ text: error, timer: 9000 });
    })
  };

  return (

    <>
    {isResetPassword && 
     <div className="forgotten-password-container">
     <div className="header-part">
       <h1 className="title">MOT DE PASSE OUBLIÉ ?</h1>
       <p className="subtitle"> SAISIR VORE ADDRESSE E-MAIL </p>
     </div>
     <div className="form-part">
     <Loader isLoading={isLoading} />

     <form onSubmit={formik.handleSubmit}>

         <TextField  placeholder="Votre addresse email" 
                     variant="outlined"
                     label="Email"
                     name="email"
                     value={formik.values.email}
                     onChange={formik.handleChange}
                     type="text"
                     style={{width:'100%'}}
                      />

               {formik.errors.email && (
                 <small className="helper-text">
                   <InlineIcon icon="ci:error-outline" /> {formik.errors.email}
                 </small>
               )}
             
         <Button variant="contained" 
                 color='tertiary'
                 type="submit"
                 sx={{marginTop:'30px'}}
                 // onClick={()=>{
                 //   goTo(routePaths.authChildren.resetPasswordAbsolute)
                 // }}
                 > VALIDER</Button>

         </form>

     </div>
     <div className="footer-part">
         <Link className="link-primary"
               to={routePaths.authChildren.signInAbsolute} >
                 Se connecter</Link>
         
     </div>
   </div>
   }

   {
    !isResetPassword && (
      <ResetPasswordForm
        idUser={currentIdUser}
      />
    )
   }
    </>

   
  )
}

export default ForgottenPasswordForm;
